import React from 'react';
import { endpoint } from '../../../views/pages/manage/common/constant';
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, updateRequest } from '../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { transferTypes } from '../transferSetup/transferApprovalConfig/addEditCofigDialog/utils';
import { Tooltip } from '@mui/material';
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";

export const EMPTY_FILTER_FORM = {
    businessAreaIds: [],
    termIds: [],
    academicGroupIds: [],
    transferTypes: [],
    approvalStatus: [],
    requestDateFrom: '',
    requestDateTo: ''
}

export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(endpoint?.term?.getAllActive, "termDispValue", "id"),

        dropdownMapping(
            endpoint.academic_group.getAllActive,
            "academicGroupDispValue",
            "id"
        ),

        dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "id",
            "businessAreaDesc"
        ),
    ]);

    return {
        term: dropdown[0],
        stream: dropdown[1],
        businessAreas: dropdown[2],
    };
};

export const statusFilterOptions = [
    { label: 'Rejected', value: 'REJECTED' },
    { label: 'Pending', value: 'In Progress' },
    { label: 'All', value: 'ALL' },
]


export const getFilterFormFields = (dropdownData, filterForm) => {
    const { businessAreas, term, stream } = dropdownData;

    return [
        {
            label: 'Branch',
            type: 'select',
            items: businessAreas,
            formKey: 'businessAreaIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select branch",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Term',
            type: 'select',
            items: term,
            formKey: 'termIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Term",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Academic Group',
            type: 'select',
            items: stream,
            formKey: 'academicGroupIds',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Academic Group",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Transfer Types',
            type: 'select',
            items: transferTypes,
            formKey: 'transferTypes',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Tranfer Type",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Approval Status',
            type: 'select',
            items: statusFilterOptions,
            formKey: 'approvalStatus',
            onChange: () => { },
            loading: false,
            isMulti: false,
            placeholder: "Select Status",
            disbabled: false,
            isShowCount: true
        },
        {
            label: 'Request Date From',
            type: 'date',
            formKey: 'requestDateFrom',
            onChange: () => { },
            placeholder: "Select date",
            disabled: false,
            minDate: '',
            maxDate: '',
        },
        {
            label: 'Request Date To',
            type: 'date',
            formKey: 'requestDateTo',
            onChange: () => { },
            placeholder: "Select date",
            disabled: false,
            minDate: filterForm?.requestDateFrom,
            maxDate: '',
        },
    ]
}


export const getStatusChipInfo = (row) => {

    const { approvalStatus, remarks = "" } = row;


    switch (true) {

        case approvalStatus?.includes("REJECTED"): {
            return {
                text: (
                    <span>
                        Rejected
                        <Tooltip title={remarks || "-"}>
                            <span className='ml-2'><InfoIconSolid color={"#B32306"} /></span>
                        </Tooltip>
                    </span>
                ),
                bgColor: "#F9D9D7",
                textColor: "#B32306"
            }
        }

        case approvalStatus?.includes('PENDING'): {
            const isL1 = approvalStatus?.includes("L1");
            const text = `Pending at ${isL1 ? 'L1' : 'L2'}`;
            return {
                text: text,
                bgColor: "#FFEDC8",
                textColor: "#A17217"
            }

        }

        case approvalStatus?.includes('APPROVED'): {
            return {
                text: 'Approved',
                bgColor: "#BBE2CE",
                textColor: "#0B442D"
            }

        }

        case approvalStatus?.includes('SENT_CORRECTION'): {
            return {
                text: 'Sent For Correction',
                bgColor: "#F5F5F5",
                textColor: "#262626"
            }

        }

        case approvalStatus?.includes('SUBMITTED'): {
            return {
                text: (<span>
                    Submitted
                    <Tooltip title={"Transfer Payment Pending"}>
                        <span className='ml-2'><InfoIconSolid color={"#262626"} /></span>
                    </Tooltip>
                </span>),
                bgColor: "#F5F5F5",
                textColor: "#262626"
            }

        }


    }

};

export const labelStyles = {
    margin: '4px',
    color: '#525f7f',
    fontWeight: 600,
    fontSize: '0.875rem'
}

const updatedStatusList = {
    "ALL": [],
    "In Progress": ["PENDING"],
    "REJECTED": ["REJECTED"],
}


export const getRequests = async ({
    pageNo = 0,
    pageSize,
    filters,
    dropdowns
}) => {
    const businessAreaIds = filters?.businessAreaIds?.length ? filters?.businessAreaIds : dropdowns?.businessAreas;
    const updatedFilters = {
        ...filters,
        businessAreaIds
    }
    let req = updateRequest({ ...updatedFilters, pageNo, pageSize });
    req = {
        ...req,
        approvalStatusList: updatedStatusList[req.approvalStatus]
    }
    return fetchAllPostPromisedData(`${endpoint.transferApproval.search}?offset=${pageNo}`, req);

}

export const getApprovalPermissions = (approvalConfigs = [], roleId, approvalRequest, allBusinessAreas) => {

    const {
        outBusinessUnitId,
        outAcademicCareerId,
        transferType,
        inBusinessUnitId,
        inAcademicCareerId,
        approvalStatus
    } = approvalRequest;

    let transferBuId = outBusinessUnitId, transferCareerId = outAcademicCareerId;

    if (approvalStatus === 'L2_PENDING') {
        transferBuId = inBusinessUnitId;
        transferCareerId = inAcademicCareerId;
    }

    let trfTypeAndRolesMappingRow = {};

    approvalConfigs.forEach(config => {
        const { businessAreas, academicCareers, transferTypeRoleMappingDtoList } = config;

        const mappingRow = transferTypeRoleMappingDtoList?.find(el => el?.transferType === transferType)

        if (
            businessAreas?.includes(transferBuId) &&
            academicCareers?.includes(transferCareerId) &&
            !!mappingRow
        )
            trfTypeAndRolesMappingRow = mappingRow;

    })

    const { l1ApprovalRoles = [], l2ApprovalRoles = [] } = trfTypeAndRolesMappingRow;

    let isL1Approver = false, isL2Approver = false;

    if (allBusinessAreas?.find(bu => bu?.value == transferBuId)) {
        isL1Approver = l1ApprovalRoles?.includes(roleId);
        isL2Approver = l2ApprovalRoles?.includes(roleId)
    }

    return { isL1Approver, isL2Approver, l1ApprovalRoles, l2ApprovalRoles };

}

export const updateApprovalRequests = (list, dropdowns, roleId, approvalConfigs) => {
    const { businessAreas } = dropdowns;
    return list?.map(el => {
        return {
            ...el,
            businessArea: businessAreas?.find(bu => bu?.value === el?.outBusinessUnitId),
            ...getApprovalPermissions(approvalConfigs, roleId, el, businessAreas)
        }
    })
}

export const getRoleId = async (roleType) => {
    const response = await fetchAllPromisedData(endpoint.role_Name.getAllActive, true);
    if (response?.code === 200) {
        const role = response?.data?.find(item => item.roleName === roleType);
        return role?.id;
    }
}

export const approverActionAndDispValueMapping = {
    "REJECT": 'rejected',
    "CORRECTION": "sent for correction",
    "APPROVE": "approved"
}